<template>
  <div class="contents-wrap">
    <div class="box-titles">
        <a-breadcrumb>
            <a-breadcrumb-item>
            <a @click="queryByPid(0)">{{ $t("moduleTitles.root") }}</a>
            </a-breadcrumb-item>
            <a-breadcrumb-item
            v-for="(item, index) in folderDepthList"
            :key="index"
            >
            <a @click="queryByPid(item.id)">{{ item.name }}</a>
            </a-breadcrumb-item>
        </a-breadcrumb>
    </div>
    <div
      v-infinite-scroll="handleInfiniteOnLoad"
      class="demo-infinite-container"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <a-list
        :data-source="dataSourse"
        :grid="{ xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }"
      >
        <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
          <div class="dir-wrapper" v-if="item.dir_id != undefined">
            <a-checkbox
              class="item-base"
              :value="item.id"
              :key="item.id"
              :checked="item.id==selectedId ? true :false"
              @change="onChange"
            >
              <div class="material-item">
                  <div class="item-img">
                    <img :src="item.cover=='' ? '/ssr/static/default.png' : item.cover" />
                  </div>
                <span class="item-name">{{ item.name }}</span>
              </div>
            </a-checkbox>
          </div>
          <div class="dir-wrapper" v-else @click="queryByPid(item.id)">
            <a-icon
              type="folder"
              theme="filled"
              style="color: #1790ff; font-size: 40px"
            />
            <span class="dir-title">{{ item.name }}</span>
          </div>
        </a-list-item>
        <div v-if="loading && !busy" class="demo-loading-container">
          <a-spin />
        </div>
      </a-list>
    </div>
  </div>
</template>

<script>
import {
  materialPageQuery,
  getFolderDepth,
} from "@/api/planeMaterial";
import infiniteScroll from "vue-infinite-scroll";
import { mapGetters } from "vuex";

export default {
  name: "MaterialList",
  directives: { infiniteScroll },
  props: {
    type:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      loading: false,
      busy: false,
      folderDepthList: [],
      dataSourse: [],
      searchParam: {
        current_page: 1,
        per_page: 30,
        pid: 0,
        name: "",
        type:5,
        order: {},
      },
      selectedList: [],
      selectedId: 0,
      isFilterScence: false,
    };
  },
  beforeMount() {},
  watch: {},
  computed: {
    ...mapGetters(["vrbase"]),
  },
  mounted() {
    if (this.$attrs.isFilterScence) {
      this.isFilterScence = this.$attrs.isFilterScence;
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      materialPageQuery(this.searchParam)
        .then((res) => {
          this.loading = false;
          if (res.code === 1) {
            let lastPage = Math.ceil(
              res.data.total / this.searchParam.per_page
            );
            if (this.searchParam.current_page > lastPage) {
              this.busy = true;
              return false;
            }
            this.searchParam.current_page++;
            // vr編輯需要過濾已經選擇的場景
            if (this.isFilterScence) {
              this.handleVrEditScenes(res.data.records);
            } else {
              this.dataSourse = [...this.dataSourse, ...res.data.records];
            }
            this.busy = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
      getFolderDepth({ id: this.searchParam.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    resetLoad() {
      this.searchParam.current_page = 1;
      this.dataSourse = [];
      this.loadData();
    },
    queryByPid(pid) {
      this.searchParam.current_page = 1;
      this.searchParam.pid = pid;
      this.dataSourse = [];
      this.loadData();
      this.$emit("dirChange", pid);
    },
    onChange(e) {
      if (e.target.checked) {
        this.selectedId = e.target.value;
        let selectInfo = {};
        this.dataSourse.filter((item) => {
          if (item.dir_id != undefined && item.id === e.target.value) {
            selectInfo = item;
          }
        });
        //this.selectedList.push(selectInfo);
        this.selectedList = [selectInfo];
      } else {
        this.selectedList.splice(
          this.selectedList.findIndex((item) => item.id === e.target.value.id),
          1
        );
      }
      this.$emit("selected", this.selectedList);
    },
    handleInfiniteOnLoad() {
      this.loadData();
    },
    handleSearch(name) {
      this.searchParam.current_page = 1;
      this.searchParam.name = name;
      this.dataSourse = [];
      this.loadData();
    },
    // 過濾已經選擇的場景
    handleVrEditScenes(listData) {
      //獲取已有的場景的pid
      let pidList = [];
      for (let key in this.vrbase.scenes) {
        if(typeof Number(this.vrbase.scenes[key].pid) === "number" ){
        pidList.push(~~this.vrbase.scenes[key].pid);
        }
      }
      const filterData = [];
      for (let i = 0; i < listData.length; i++) {
        const temp = listData[i];
        if (pidList.includes(~~temp.id)) continue;
        filterData.push(temp);
      }
      this.dataSourse = [...this.dataSourse, ...filterData];
    },
  },
};
</script>

<style lang="less" scoped>
.dir-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 110px;
}
@media (max-width: 767px) {
  .dir-wrapper {
    height: 70px;
  }
}
.card-wrapper {
  width: 100px;
  height: 100px;
}
.contents-wrap {
  .upload-btn {
    position: absolute;
    top: -6px;
    right: 0;
    flex-shrink: 0;
  }
  .box-titles {
    position: relative;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }
}
.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 400px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.item-base {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
}
.material-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.item-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  margin-right: 5px;
}
.item-img img {
  width: 100%;
  height: 100%;
}
.item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
}
.dir-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dir-wrapper:hover {
  cursor: pointer;
  color: #1890ff;
}
</style>
